import * as React from 'react';
import NextLink from 'next/link';

export const Link = React.forwardRef<
  React.ElementRef<typeof NextLink>,
  React.ComponentPropsWithoutRef<typeof NextLink>
>((props, ref) => (
  <NextLink ref={ref} {...props}>
    {props.children}
  </NextLink>
));
